import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const setObserver = () => {
  eventBus.$on('changeGuestSgdt', async (gpds_id) => {
    try {
      const baseUrl = window.config.ePersonamService.ePersonamHost + '/' + window.locale;
      const checkDoppioProfiloUrl = `${baseUrl}/domestic/check_doppio_profilo.json?gpds_id=${gpds_id}`;

      const { data } = await apiConnector().get(checkDoppioProfiloUrl);

      const doppio_profilo = data[0].doppio_profilo;

      if (!doppio_profilo) {
        document.querySelector('.agenda_plan_new_activity_profile_select_container').classList.add('not-clickable');
        document.querySelector('.agenda_plan_new_activity_profile_select_select').classList.remove('mychzn-obbligatorio');

        eventBus.$emit('emptyProfile');
      } else {
        document.querySelector('.agenda_plan_new_activity_profile_select_container').classList.remove('not-clickable');
        document.querySelector('.agenda_plan_new_activity_profile_select_select').classList.add('mychzn-obbligatorio');

        eventBus.$emit('changeGuestSgdtProfile', gpds_id);
      }
    } catch (exception) {
      errorManager(exception);
    }
  });
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.AdiSgdtDom = {
  init: init,
};
